import { call, put, takeLatest } from 'redux-saga/effects';
import { captureException } from '@sentry/react';

import { coreClient as client } from '@app/helpers/requests/client';
import {
  getResponseData,
  responseFailed,
} from '@app/helpers/requests/bennieFetch';
import {
  fetchSubsidiariesRequest,
  fetchSubsidiariesSuccess,
  fetchSubsidiariesError,
} from './index';

// BCP-3441: returns the subsidiaries the current user has access to, id + name.
export function* fetchSubsidiaries() {
  try {
    const response = yield call(client.get, `/v1/subsidiaryAccesses`);

    if (responseFailed(response.status)) {
      const error = new Error('Error fetching subsidiary accesses');
      error.status = response.status;
      throw error;
    }

    const data = getResponseData(response);
    const list = (data?.subsidiaries || []).map(subsidiary => ({
      id: subsidiary.id,
      name: subsidiary.name || '',
    }));

    yield put(fetchSubsidiariesSuccess({ list }));
  } catch (error) {
    captureException(error, {
      tags: { section: 'ManageUsersSubsidiaries' },
      extra: { status: error.status },
    });
    yield put(
      fetchSubsidiariesError({ error: error.message || 'not allowed' }),
    );
  }
}

export function* adminFetchSubsidiariesWatcher() {
  yield takeLatest(fetchSubsidiariesRequest, fetchSubsidiaries);
}
